import React from "react";
import {
  DashboardIcon,
  PaymentTrackingIcon,
  AlertsIcon,
  CommunicationIcon,
} from "./icons/SvgIcons";

const solutions = [
  {
    icon: DashboardIcon,
    title: "One dashboard for everything",
    text: "See all your properties, tenants, and payments at a glance. No more switching between apps.",
  },
  {
    icon: PaymentTrackingIcon,
    title: "Real time payment tracking",
    text: "Mark payments as they come in. Full, partial, or multi month. Always know who's paid and who hasn't.",
  },
  {
    icon: AlertsIcon,
    title: "Automatic overdue detection",
    text: "Paysafi flags overdue tenants instantly. See outstanding balances across months, with arrears carried forward.",
  },
  {
    icon: CommunicationIcon,
    title: "SMS & AI call reminders",
    text: "Send bulk SMS reminders or let the AI voice agent call tenants automatically. No more awkward conversations.",
  },
];

export default function SolutionSection() {
  return (
    <section className="border-b border-gray-100 bg-white py-16 dark:border-gray-800 dark:bg-gray-950 sm:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-wide text-indigo-600 dark:text-indigo-400">
            The solution
          </span>
          <h2 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-4xl">
            Paysafi handles it all for you
          </h2>
          <p className="mt-4 text-lg text-gray-600 dark:text-gray-400">
            Everything you need to manage rent collection in one place.
          </p>
        </div>
        <div className="mt-14 grid gap-8 sm:gap-10 lg:grid-cols-2">
          {solutions.map((s) => (
            <div key={s.title} className="flex gap-4 sm:gap-5">
              <div className="flex-shrink-0">
                <s.icon size={56} bg="#EEF2FF" />
              </div>
              <div className="min-w-0">
                <h3 className="text-base font-semibold text-gray-900 dark:text-white sm:text-lg">{s.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-gray-600 dark:text-gray-400">{s.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
